import React from 'react';

const Home = () => { 

    return (
        <div className="homepage-container">
          <div className="overlay">
            <h1 className="homepage-title">Welcome to the Movie Hunt App</h1>
            <p className="homepage-subtitle">
              Discover movies, explore OTT platforms, and find where to watch your favorite movies!
            </p>
          </div>
        </div>
      );
};

export default Home;
